import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Services } from "appworks/services/services";
import { TotalStakeStepperControl } from "appworks/ui/controls/standard/stepper/total-stake-stepper-control";
import { gamevy } from "gamevy/gamevy";

export class GamevyTotalStakeStepperControl extends TotalStakeStepperControl {
    private previousTotalStake: number;

    constructor(downButton: FlexiButton, upButton: FlexiButton, valueText?: FlexiText) {
        super(downButton, upButton, valueText);
        this.previousTotalStake = Services.bet.getTotalStake();
    }

    protected updateValues(): void {
        super.updateValues();

        const totalStake = Services.bet.getTotalStake();
        gamevy.commonUI.updateBet({ amount: Services.bet.getTotalStake() });
        if (
            this.previousTotalStake != null &&
            this.previousTotalStake !== Services.bet.getTotalStake()
        ) {
            gamevy.commonUI.updateWin({ amount: 0 });
        }
        this.previousTotalStake = totalStake;
    }
}
